import React from 'react';
import { ToastContainer, ToastContainerProps } from 'react-toastify';

export const Toaster: React.FC<ToastContainerProps> = (props) => {
  return (
    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      {...props}
    />
  );
};
